import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { TypeRankingsEntities } from 'client/data/models/type-rankings-entities';
import { getProfileStockPhotoBySize, SOURCES } from 'client/utils/image-helpers';
import {
  getUrlSlugByName,
  TYPE_TITLE_LOWERCASE_EXCEPTIONS_MAPPING,
} from 'site-modules/shared/utils/upper-funnel/type-mapping';
import { getAnchorName } from 'site-modules/shared/utils/upper-funnel/type-rankings';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';
import { ArrowLink } from 'site-modules/shared/components/arrow-link/arrow-link';
import { Image } from 'site-modules/shared/components/image/image';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

import './best-category-card.scss';

export function BestCategoryCard({
  category: { edmundsTypeCategory, segmentRatings, displayName, id },
  isLazyImage = false,
}) {
  const type = edmundsTypeCategory.toLowerCase();
  const typeRankingsUrl = `/${getUrlSlugByName(type)}/#${getAnchorName(displayName)}`;

  const validSegmentRatings = segmentRatings.filter(segmentRating => segmentRating?.modelYear);
  if (!validSegmentRatings.length) {
    return null;
  }

  const title = `Best ${displayName}`;
  const rankingsLinkType = linkDisplayName =>
    linkDisplayName &&
    linkDisplayName
      .toLowerCase()
      .substring(0, linkDisplayName.length - 1)
      .replace('suv', 'SUV')
      .replace('SUVs', 'SUV');

  const firstVehicle = validSegmentRatings[0];
  const imageUrl = getProfileStockPhotoBySize(
    {
      make: firstVehicle.modelYear.makeSlug,
      model: firstVehicle.modelYear.modelSlug,
      year: firstVehicle.modelYear.year,
      submodel: firstVehicle.slugRankedSubmodel || '',
    },
    300,
    200
  );

  return (
    <div className="best-category-card mb-1 d-flex flex-column text-gray-darker">
      <div className="best-category-image">
        <AspectRatioContainer aspectRatio="3:2">
          <Link to={typeRankingsUrl} rel="nofollow">
            <Image imageId={imageUrl} alt={title} source={SOURCES.MEDIA} lazy={isLazyImage} className="w-100" />
          </Link>
        </AspectRatioContainer>
      </div>
      <h3 className="heading-5 mb-0 text-capitalize">{title}</h3>
      <ul className="list-unstyled mb-1_5">
        {validSegmentRatings.map(
          ({
            modelYear: { makeName, makeSlug, modelName, modelSlug, year },
            rankedSubmodel,
            modelDisplayOverride,
            slugRankedSubmodel,
            rank,
          }) => (
            <Row tag="li" className="row mt-0_5 text-gray-darker" key={`${id}-${rank}-${makeSlug}-${modelSlug}`}>
              <Col xs={2} sm={1} className="fw-bold">
                <span className="small">#</span>
                {rank}
              </Col>
              <Col>
                <Link to={getCoreUrl({ makeSlug, modelSlug, year, submodelSlug: slugRankedSubmodel })}>
                  {year} {makeName}{' '}
                  {modelDisplayOverride || (rankedSubmodel ? `${modelName} ${rankedSubmodel}` : modelName)}
                </Link>
              </Col>
            </Row>
          )
        )}
      </ul>
      <ArrowLink to={typeRankingsUrl}>
        See{' '}
        {rankingsLinkType(displayName)
          ? rankingsLinkType(displayName)
          : TYPE_TITLE_LOWERCASE_EXCEPTIONS_MAPPING[type] || type}{' '}
        rankings
      </ArrowLink>
    </div>
  );
}

BestCategoryCard.propTypes = {
  category: TypeRankingsEntities.VehicleRanking.isRequired,
  isLazyImage: PropTypes.bool,
};
